"use client";
import React from "react";
import * as yup from "yup";
import { Modal, Divider, Segment, Icon, Grid, Loader } from "semantic-ui-react";
import { Title, Field, ButtonItem, InText, Segmant } from "../../components";
import { Button, Form, Input } from "formik-semantic-ui";
import { styles } from "./element";

const SignupModal = ({
  open,
  submit,
  next,
  iconclick,
  s_firstname_err_status,
  s_firstname_err_msg,
  s_email_err_status,
  s_email_err_msg,
  s_lastname_err_status,
  s_lastname_err_msg,
  firstNameChage,
  s_password_err_status,
  s_password_err_msg,
  s_confirmpassword_err_status,
  s_confirmpassword_err_msg,
  insertmessage,
  onChangeAgentCheckbox,
  isAgentChecked,
  isSaving,
}) => {
  const validations = yup.object().shape({
    first_name: yup
      .string()
      .min(3, "Minimum 3 characters")
      .max(15, "Maximum 15 characters")
      .required("First Name is required"),
    last_name: yup
      .string()
      .min(3, "Minimum 3 characters")
      .max(15, "Maximum 15 characters")
      .required("Last Name is required"),
    email: yup.string().email("Invalid Email").required("Email is required"),
  });

  return (
    <Modal
      open={open}
      size="tiny"
      style={styles}
      className="signup_modal"
      centered
    >
      <Segment padded>
        <Grid className="signup_main">
          <Grid.Row>
            <Grid.Column width={16}>
              <Title textAlign="center" content="Join" size="large" />
              <span onClick={iconclick} className="signup_close_icon">
                <Icon link size="large" name="close" />
              </span>
              <p className="signup_tagline">
                Leave Reviews - Ask & Answer Questions - Personalize Overall
                Score
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider />
        <Divider hidden />
        <Modal.Content>
          <Form
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              display_name: "",
              password: "",
              confirmpassword: "",
              isagent: "true",
              id: "smodal",
            }}
            onSubmit={(values) => submit(values)}
            ignoreLoading={true}
            // validationSchema={validations}
          >
            <Form.Group widths="2">
              <Input
                name="first_name"
                inputProps={{
                  placeholder: "First Name",
                }}
              />
              <Input
                name="last_name"
                inputProps={{
                  placeholder: "Last Name",
                }}
              />
            </Form.Group>
            {s_firstname_err_status ? (
              <span
                style={{
                  margin: "0.28571429rem 0",
                  color: "rgb(159, 58, 56)",
                  fontSize: "0.92857143em",
                  padding: 3,
                  float: "left",
                }}
              >
                {s_firstname_err_msg}
              </span>
            ) : null}
            {s_lastname_err_status ? (
              <span
                style={{
                  margin: "0.28571429rem 0",
                  color: "rgb(159, 58, 56)",
                  fontSize: "0.92857143em",
                  padding: "3px",
                  float: "right",
                }}
              >
                {s_lastname_err_msg}
              </span>
            ) : null}
            <Input
              name="display_name"
              inputProps={{
                placeholder: "Display Name (optional)",
              }}
            />

            <Input
              name="email"
              inputProps={{
                placeholder: "Email",
              }}
            />

            {s_email_err_status ? (
              <span className="sui-error-message">{s_email_err_msg}</span>
            ) : null}
            <Input
              name="password"
              inputProps={{
                placeholder: "Password",
                type: "password",
              }}
            />
            {s_password_err_status ? (
              <span className="sui-error-message">{s_password_err_msg}</span>
            ) : null}
            <Input
              name="confirmpassword"
              inputProps={{
                placeholder: "Confirm Password",
                type: "password",
              }}
            />
            {s_confirmpassword_err_status ? (
              <span className="sui-error-message">
                {s_confirmpassword_err_msg}
              </span>
            ) : null}
            <Divider />
            <div className="realestate_agent_check">
              <label>Joining as a Real Estate Agent?</label>
              &nbsp;
              <input
                type="checkbox"
                checked={isAgentChecked || false}
                name="isagent"
                onChange={(e) => onChangeAgentCheckbox(e)}
              />
            </div>
            <Button.Submit fluid primary disabled={isSaving}>
              {isSaving && <Loader active inline size="tiny" />} Join
            </Button.Submit>
            {insertmessage != "" && (
              <p style={{ textAlign: "center" }}>
                <span className="sui-error-message">{insertmessage}</span>
              </p>
            )}
          </Form>
          <Segmant>
            <span style={{ cursor: "pointer" }} onClick={(e) => next(e)}>
              <InText
                id="smodal"
                content="Sign In"
                floated="right"
                color="blue"
              />
            </span>
            <InText content="Already a Member ?" floated="right" />
          </Segmant>
          <Divider hidden />
          <Divider hidden />
          <p className="term_registration">
            By joining you agree to Houseberry's{" "}
            <a href="/Policies" title="Terms of Use and Privacy Policy">
              Terms of Use and Privacy Policy
            </a>
          </p>
        </Modal.Content>
      </Segment>
    </Modal>
  );
};

// SignupModal.propTypes = {
// 	title : PropTypes.string,
// };
export default SignupModal;
